// Lib
import React, { useMemo } from 'react';
import { Typography } from '@mui/material';
import { useLocation } from 'react-router-dom';

// Components
import Breadcrumbs from '../../Breadcrumbs';

// Hooks
import useUI from '../../../hooks/useUI';

// Constants
import {
  REVIEW_ORDER_BREADCRUMBS,
  SHIPPING_DETAILS_BREADCRUMBS,
} from '../../../constants/cart';

// Styles
import { useStyles } from './HeaderStyles';

const Header = (props) => {
  const empty = props?.empty || false;
  const { classes } = useStyles();
  const { isDesktopMode } = useUI();
  const { pathname } = useLocation();

  const items = useMemo(() => {
    if (pathname === '/cart/shipping-details') {
      return SHIPPING_DETAILS_BREADCRUMBS;
    }
    if (pathname === '/cart/review-order') {
      return REVIEW_ORDER_BREADCRUMBS;
    }
  }, [pathname]);

  return (
    <>
      {empty ? (
        <></>
      ) : (
        <div className={classes.bar}>
          {isDesktopMode ? (
            <Breadcrumbs items={items} />
          ) : (
            <Typography className={classes.title} variant="h2">
              {items[items.length - 1].title}
            </Typography>
          )}
        </div>
      )}
    </>
  );
};

export default Header;
